/**
 * Animate statistic counters when they scroll into view.
 */

function isInViewport(element: Element): boolean {
    const rect = element.getBoundingClientRect();
    return (
        rect.bottom > 0 &&
        rect.right > 0 &&
        rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left < (window.innerWidth || document.documentElement.clientWidth)
    );
}

function animateValue(element: HTMLElement, start: number, end: number, duration: number): void {
    const range = end - start;
    const minTimer = 50;
    const stepTime = Math.abs(Math.floor(duration / range));
    const actualStepTime = Math.max(stepTime, minTimer);
    const startTime = Date.now();
    const endTime = startTime + duration;

    const timer = window.setInterval(() => {
        const now = Date.now();
        const remaining = Math.max((endTime - now) / duration, 0);
        const value = Math.round(end - remaining * range);
        element.textContent = value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');

        if (value === end) {
            window.clearInterval(timer);
        }
    }, actualStepTime);
}

export function initStatisticsCounter(): void {
    const counters = document.querySelectorAll<HTMLElement>('[data-stat-count]');
    if (!counters.length) {
        return;
    }

    const animationTriggered = new WeakSet<HTMLElement>();

    const checkAndAnimate = (): void => {
        counters.forEach((element) => {
            if (!isInViewport(element) || animationTriggered.has(element)) {
                return;
            }

            animationTriggered.add(element);
            const end = Number.parseInt(element.dataset.statEnd ?? '0', 10);
            animateValue(element, 0, Number.isNaN(end) ? 0 : end, 3000);
        });
    };

    window.addEventListener('scroll', checkAndAnimate, { passive: true });
    checkAndAnimate();
}
